import React from 'react';
import PropTypes from 'prop-types';
import FeatureImageQuoteContent from "components/FeatureImageQuoteContent";
import FeatureMediaWithCaption from "components/FeatureMediaWithCaption";
import QuoteBlock from "components/QuoteBlock";
import VideoModel from "components/Models/Video/Video";
import MediaWrapper from "components/MediaWrapper";
import cn from 'classnames';
import "./FeatureMediaBlock.scss";

export const VIDEO_LABELS = {
    DESKTOP: "desktop",
    MOBILE: "mobile"
};

const FeatureMediaBlock = ({
    media,
    text,
    quote
}) => {
    const isVideoMedia = media && media.video;
    const isText = text && !isVideoMedia;
    const isQuote = quote && !text && !isVideoMedia;

    const mediaObj = 
        isVideoMedia ? 
            {
                ...media,
                video: [
                    {
                        ...media.video, 
                        label: VIDEO_LABELS.DESKTOP
                    },
                    {
                        ...media.videoMobile, 
                        label: VIDEO_LABELS.MOBILE
                    }
                ]
            } : 
            media;

    return (
        <MediaWrapper 
            media={mediaObj}
            stickyDuration={isQuote ? 100 : null}
            theme={isQuote ? MediaWrapper.themes.sticky : null}
            className={cn('feature-media-block', {
                ['feature-media-block_with-video'] : isVideoMedia
            })}
        >
            {isText && <FeatureMediaWithCaption text={text} />}
            {isQuote && <FeatureImageQuoteContent quote={quote} />}
        </MediaWrapper>
    );
};

FeatureMediaBlock.propTypes = {
    media: PropTypes.shape({
        video: PropTypes.shape(VideoModel.propTypes),
        videoMobile: PropTypes.shape(VideoModel.propTypes),
        image: PropTypes.string,
        imageMobile: PropTypes.string,
        alt: PropTypes.string
    }),
    text: PropTypes.string,
    quote: PropTypes.shape(QuoteBlock.propTypes)
};

export default FeatureMediaBlock;



// WEBPACK FOOTER //
// ./src/components/FeatureMediaBlock/FeatureMediaBlock.jsx